import React from "react";
import { Line, Bar, Pie, PolarArea, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  RadialLinearScale,
  Tooltip,
} from "chart.js";

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  RadialLinearScale,
  Tooltip
);

export const LineChartExample = ({ data, legend }) => {
  return (
    <Line
      className="line-chart"
      data={data}
      options={{
        plugins: {
          legend: {
            display: legend,
            labels: {
              boxWidth: 12,
              padding: 20,
              color: "#6783b8",
            },
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#eff6ff",
            titleFont: { size: 13 },
            titleColor: "#6783b8",
            titleMarginBottom: 6,
            bodyColor: "#9eaecf",
            bodyFont: { size: 12 },
            bodySpacing: 4,
            yPadding: 10,
            xPadding: 10,
            footerMarginTop: 0,
            displayColors: false,
          },
        },
        maintainAspectRatio: false,
        scales: {
          y: {
            display: true,
            ticks: {
              beginAtZero: false,
              font: { size: 12 },
              color: "#9eaecf",
              padding: 10,
            },
            grid: {
              tickLength: 0,
            },
          },
          x: {
            display: true,
            ticks: {
              font: { size: 12 },
              color: "#9eaecf",
              padding: 5,
            },
            grid: {
              color: "transparent",
              tickLength: 10,
              offset: true,
            },
          },
        },
      }}
    />
  );
};

export const BarChartExample = ({ data, stacked }) => {
  return (
    <Bar
      data={data}
      options={{
        plugins: {
          legend: {
            display: false,
            labels: {
              boxWidth: 30,
              padding: 20,
              color: "#6783b8",
            },
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#eff6ff",
            titleFont: { size: 13 },
            titleColor: "#6783b8",
            titleMarginBottom: 6,
            bodyColor: "#9eaecf",
            bodyFont: { size: 12 },
            bodySpacing: 4,
            yPadding: 10,
            xPadding: 10,
            footerMarginTop: 0,
            displayColors: false,
          },
        },
        maintainAspectRatio: false,
        scales: {
          y: {
            display: true,
            stacked: !!stacked,
            ticks: {
              beginAtZero: true,
              font: { size: 12 },
              color: "#9eaecf",
              padding: 5,
            },
            grid: {
              tickLength: 0,
            },
          },
          x: {
            display: true,
            stacked: !!stacked,
            ticks: {
              font: { size: 12 },
              color: "#9eaecf",
              padding: 5,
            },
            grid: {
              color: "transparent",
              tickLength: 10,
            },
          },
        },
      }}
    />
  );
};

export const PieChartExample = ({ data }) => {
  return (
    <Pie
      data={data}
      options={{
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#eff6ff",
            titleFont: { size: 13 },
            titleColor: "#6783b8",
            titleMarginBottom: 6,
            bodyColor: "#9eaecf",
            bodyFont: { size: 12 },
            bodySpacing: 4,
            yPadding: 10,
            xPadding: 10,
            footerMarginTop: 0,
            displayColors: false,
          },
        },
        rotation: -0.2,
        maintainAspectRatio: false,
      }}
    />
  );
};

export const DoughnutExample = ({ data }) => {
  return (
    <Doughnut
      data={data}
      options={{
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#eff6ff",
            titleFont: { size: 13 },
            titleColor: "#6783b8",
            titleMarginBottom: 6,
            bodyColor: "#9eaecf",
            bodyFont: { size: 12 },
            bodySpacing: 4,
            yPadding: 10,
            xPadding: 10,
            footerMarginTop: 0,
            displayColors: false,
          },
        },
        rotation: 1,
        cutout: "40%",
        maintainAspectRatio: false,
      }}
    />
  );
};

export const PolarExample = ({ data }) => {
  return (
    <PolarArea
      data={data}
      options={{
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#eff6ff",
            titleFont: { size: 13 },
            titleColor: "#6783b8",
            titleMarginBottom: 6,
            bodyColor: "#9eaecf",
            bodyFont: { size: 12 },
            bodySpacing: 4,
            yPadding: 10,
            xPadding: 10,
            footerMarginTop: 0,
            displayColors: false,
          },
        },
        maintainAspectRatio: false,
      }}
    />
  );
};
